<RbEmptyHeader>
  <div class="Controls" slot="mainControls">
    <a href="/" on:click|preventDefault|stopPropagation="{() => openState('signIn')}"
       class="aBtn asLarge CustomButton" data-icon="vpn_key">Sign In</a>

    <a href="/" on:click|preventDefault|stopPropagation="{() => openState('signUp')}"
       class="aBtn asLarge CustomButton" data-icon="account_box">Sign Up</a>

    <a href="http://readybidnet.freshdesk.com" target="_blank"
       class="aBtn asLarge CustomButton" data-icon="help">Need Help?</a>
  </div>
</RbEmptyHeader>

<script>
  import RbEmptyHeader from './RbEmptyHeader.svelte';
  import {$state as state} from 'root/angular-injector-provider';

  function openState(stateName, params) {
    state().go(stateName, params, {reload: true});
  }
</script>


<style lang="stylus">
  @import '../header.blocks.styl';

  .Controls {
    {Controls}
    margin-right: 5px;
  }

  .aBtn.asLarge.CustomButton {
    {CustomButton}
    margin-left: 5px;
  }
</style>